<div *ngIf="formVisible">
  <div class="filter-container">
    <form>
      <div class="title">
        <span id="icon" class="material-icons-outlined icon-archived">
          archive
        </span>
        <label for="archive-filter">Archived:</label>
      </div>

      <div class="apply-container">
        <button class="apply-filter-btn" (click)="apply()">Apply</button>
      </div>
    </form>
  </div>
</div>
